module.exports = __webpack_public_path__ + "static/media/calendar-big.4905f16b.svg";